// Marca y ordena los chatrooms si hay notificaciones nuevas y los marca como "sin leer"
/*
function orderAndMark(state){
  let newChatrooms = []
  // chatrooms que se mostrarán primero
  let topChatrooms = []
  state.notifications.forEach((notificationRoom)=>{
    let index = state.chatrooms.findIndex((cr)=>cr.chat.firebase_code == notificationRoom)
    if(index !== -1){
      let chatroom = state.chatrooms[index]
      chatroom.hasMessages = true
      topChatrooms.push(chatroom)
      // se elimina de los chatrooms
      state.chatrooms.splice(index, 1)
    }
  })
  // si quedan en los chatrooms es porque no tienen mensajes que leer
  state.chatrooms.forEach((cr)=>cr.hasMessages = false)
  newChatrooms.push(...state.chatrooms)
  newChatrooms.unshift(...topChatrooms)
  state.chatrooms = newChatrooms
}*/

function checkForNotifications(state, room){
  let hasNotif = false
  state.notifications.forEach((notificationRoom)=>{
    if(notificationRoom === room.chat.firebase_code){
      hasNotif = true
    }
  })
  return hasNotif
}

function orderRoomsAndMark(state){
  const copyRooms = JSON.parse(JSON.stringify(state.chatrooms))
  const orderedRooms = []
  state.firebaseChatrooms.forEach((doc) => {
    const id = doc.id
    const index = copyRooms.findIndex((room) => {
      if (room.chat) {
        if (id === room.chat.firebase_code) {
          return true
        }
      }
      return false
    })
    if (index !== -1) {
      let room = copyRooms[index]
      room.hasMessages = checkForNotifications(state, room)
      orderedRooms.push(room)
      copyRooms.splice(index, 1)
    }
  })
  orderedRooms.push(...copyRooms)
  state.chatrooms = orderedRooms
}

export const setNotifications = (state, data) => {
  //console.log("notifications")
  state.notifications = data
  orderRoomsAndMark(state)
}

export const setChatrooms = (state, data) => {
  state.chatrooms = data
  orderRoomsAndMark(state)
  //console.log(state.chatrooms)
}

export const setFirebaseChatrooms = (state, data) => {
  state.firebaseChatrooms = data
  orderRoomsAndMark(state)
}

export const setChatroomsSnapshot = (state, data) => {
  state.chatroomsSnapshot = data
}